import React from "react";
import PropTypes from "prop-types";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import "./PrimaryButton.scss";

const PrimaryButtonAddUsers = (props) => {
  const { onClick, disabled, text, title, usersLimitReached } = props;
  return (
    <>
      <OverlayTrigger
        placement="bottom"
        overlay={
          disabled && title !== "" && usersLimitReached === true ? (
            <Tooltip id="tooltip1" className="long-text-tooltip">
              You have reached the maximum limit of {title} User licenses for
              your TRIYO Organization. <br />
              <br />
              To add new Users, <strong>Deactivate</strong> or{" "}
              <strong>Archive</strong> existing Users to free up licenses,
              <br /> or contact your TRIYO Account Manager to procure additional
              licenses.
            </Tooltip>
          ) : (
            <Tooltip id="tooltip1">Create New User</Tooltip>
          )
        }
      >
        <Button
          className="primary-button create-btn-light"
          onClick={onClick}
          disabled={disabled}
        >
          {text}
        </Button>
      </OverlayTrigger>
    </>
  );
};

PrimaryButtonAddUsers.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  text: PropTypes.string,
  title: PropTypes.string,
  usersLimitReached: PropTypes.bool.isRequired,
};

PrimaryButtonAddUsers.defaultProps = {
  disabled: false,
  text: "Submit",
  title: "",
};

export default PrimaryButtonAddUsers;
